module.exports = __webpack_public_path__ + "static/media/TE EXTC sem II 2025-26.0cfb8a0d.pdf";